<template>
  <div class="hw-panel">
    <div v-if="title" class="hw-panel-head">
      <span class="hw-panel-title">{{ title }}</span>
      <slot name="actions">
        <span v-if="note" class="hw-muted">{{ note }}</span>
      </slot>
    </div>
    <slot />
    <div v-if="pager" class="hw-pager">
      <span class="hw-muted">Showing {{ pager.start + 1 }}–{{ pager.end }} of {{ onlyCommaFormat(pager.total) }}<slot name="pager-note" /></span>
      <div class="hw-pager-buttons">
        <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="pager.page <= 1" @click="emit('update:page', pager.page - 1)">Prev</button>
        <span class="hw-muted">{{ pager.page }} / {{ pager.page_count }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="pager.page >= pager.page_count" @click="emit('update:page', pager.page + 1)">Next</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter'

defineProps({
  title: { type: String, default: '' },
  note: { type: String, default: '' },
  pager: { type: Object, default: null }
})

const emit = defineEmits(['update:page'])

const { onlyCommaFormat } = figureFormatter()
</script>

<style scoped src="./hrWorkforce.css"></style>

<style scoped>
.hw-panel {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  padding: 16px;
  min-width: 0;
}
.hw-panel-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.hw-panel-title {
  font-weight: 700;
  color: #1e293b;
  font-size: 0.95rem;
}
.hw-pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
}
.hw-pager-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
